import styled from '@emotion/styled'

export const Sides = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
